import refreshCaptcha from "../utils/captcha-refresh";
import PPaddMessageManagementForGF from "./PPaddMessageManagementForGF";
refreshCaptcha('.pp-captcha__code-refresh', '.pp-captcha__code-img');

import PPAdressAutocomplete from "./PPAdressAutocomplete";

document.addEventListener('DOMContentLoaded', ()=> {

    document.querySelector('#input_21_10').setAttribute('readonly', 'readonly');

    const ppAddressAutocomplete = new PPAdressAutocomplete(
        'input_21_9',
        'input_21_10',
        'input_10',
        'validation_message_21_10'
    );
    ppAddressAutocomplete.main();

    //============================================================================
    const ppMessageManagement =  new PPaddMessageManagementForGF('#gform_21');
    ppMessageManagement.addElementsByID('1');
    ppMessageManagement.addElementsByID('2');
    ppMessageManagement.addElementsByID('3');
    ppMessageManagement.addElementsByID('4');
    ppMessageManagement.addElementsByID('5');
    ppMessageManagement.addElementsByID('6');
    ppMessageManagement.setElements();
});
